// extracted by mini-css-extract-plugin
module.exports = {"label":"form-label_label__7rJ3Y","bigLabel":"form-label_bigLabel__gZ3wy typography_primaryAllCaps__YeBt3"};